import { useTranslation } from "react-i18next"
import { NavigationButtons } from "~/shared/components/NavigationButtons"

import { Text } from "@oysterhr/ui"
import { useNavigate } from "react-router-dom"
import { useAccountAspect } from "@oysterhr/identity"
import { useAchPaymentMethodForm } from "../../hooks/useAchPaymentMethodForm"
import { companyPaymentMethodsPath } from "../../../../../../../utils/routeHelpers"

export const ReviewBankDetails = () => {
  const { t } = useTranslation("company_interface/CompanyPaymentMethodsPage/AchBankDetailsFlow")
  const navigate = useNavigate()
  const { accountAspect: companyId } = useAccountAspect()
  const { onSubmit, loading, formIsReady, getValues } = useAchPaymentMethodForm({
    onSuccess: () => {
      navigate(companyPaymentMethodsPath(companyId))
    },
  })
  const values = getValues()

  return (
    <div className="mt-8">
      <Text>{t("summary")}</Text>
      <div className="mt-4">
        <Text className="font-semibold">{t("accountHolderName")}</Text>
        <Text>{values.accountHolderName}</Text>
      </div>
      <div className="mt-4">
        <Text className="font-semibold">{t("routingNumber")}</Text>
        <Text>{values.routingNumber}</Text>
      </div>
      <div className="mt-4">
        <Text className="font-semibold">{t("accountNumber")}</Text>
        <Text>{values.accountNumber}</Text>
      </div>

      <NavigationButtons
        loading={loading}
        disabled={!formIsReady}
        onNext={() => {
          onSubmit(values)
        }}
        isLast
        analyticsBase="ach-bank-details"
      />
    </div>
  )
}
